module.exports = __webpack_public_path__ + "static/img/試用看看300.3fad57e9.png";